module.exports = __webpack_public_path__ + "static/media/image_3.dd9f7567.jpg";